import React from 'react';
import { DonutDoubleEverywhere } from 'prophesier/dist/wrapper/index-with-deps-react.js';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';

const data = [{
    title: "Android",
    value: 40,
    color: "rgb(86,130,216)",
    subs: [{
        title: "Samsung",
        value: 20,
        color: "rgba(86,130,216,1)"
    }, {
        title: "HTC",
        value: 10,
        color: "rgba(86,130,216,0.75)"
    }, {
        title: "Samsung",
        value: 5,
        color: "rgba(86,130,216,0.5)"
    }, {
        title: "Other",
        value: 5,
        color: "rgba(86,130,216,0.25)"
    }]
}, {
    title: "Windows",
    value: 20,
    color: "rgb(188,98,218)"
}, {
    title: "Print",
    value: 20,
    color: "rgb(196,175,84)",
    subs: [{
        title: "Samsung",
        value: 10,
        color: "rgba(196,175,84,1)"
    }, {
        title: "HTC",
        value: 10,
        color: "rgba(196,175,84,0.75)"
    }]
}, {
    title: "Other",
    value: 20,
    color: "rgb(91,100,114)"
}];

const internaltext=[{
    position: "54%",
    size: 12,
    bold: true,
    text: 'Internal Title',
    color: '#58585b'
},{
    position: "42%",
    size: 32,
    bold: false,
    text: '1234',
    color: '#58585b'
}]

class DonutSample extends React.Component {
    constructor() {
        super();
        this._onClickSlice = this._onClickSlice.bind(this);
        //this._onChange = this._onChange.bind(this)
        this.state = { 
            inttext: true, 
            legendposition: true
             }
    }
    /*
    componentDidMount() {
        const { inttext, labels } = this.state
        const { container } = this.refs
        let valueText = (inttext) ? internaltext : []
        const properties = ['inttext', 'labels']
        let toggle
        let toggleArray = []
        properties.map((element, index)=>{
            toggle = <CheckBox 
                name={`${element}`}
                id={`${element}`}
                label={`${element}`}
                toggle={true}
                disabled={false}
                reverse={true}
                onChange={this._onChange.bind(this, `${element}`)}
            />
            toggleArray.push(toggle) 
        })
        console.log(toggleArray)
        let donut = 
            <DnxDoubleDonut data={data}
                maintitle='Pie Chart Title'
                internaltext= {valueText}
                legendposition='bottom'
                labels={labels}
                onClickSlice={this._onClickSlice}
                width='500px'
                height='400px'
            ></DnxDoubleDonut>
        ReactDOM.render(<div> {toggleArray} {donut} </div>, container);
            //container.appendChild(toggle)

        //container.appendChild(donut)

        
        let refs = this.refs

        console.log(refs)
        console.log(container)
    }*/
    _onClickSlice(event) {
        console.log(event);
    }
    _onChange(event) {
        let { inttext, legendposition } = this.state
        switch(event) {
            case "inttext":
                this.setState({ inttext: !inttext })
                break;
            case "legendposition":
                this.setState({ legendposition: !legendposition })
                break;
        }
    }
    render() {
        let { inttext, legendposition } = this.state
        return (
            <div>
                <Box direction='row'
                    justify='center'
                    align='center'
                    wrap={true}
                    reverse={false}
                    margin='none'
                    >
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >
        <CheckBox 
        name='inttext'
        id='inttext'
        label='Text'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'inttext')}
         />
                        </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='legendposition'
        id='legendposition'
        label='Legend Position'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'legendposition')}
         />
                             </Box>
                    </Box> 
         
        <DonutDoubleEverywhere data={data}
            internaltext= {(inttext)? internaltext: []}
            legendposition={(legendposition)?'bottom':'right'}
            onClickSlice={this._onClickSlice}
            width='500px'
            height='400px'
        ></DonutDoubleEverywhere>
        </div>);
    }
}

export default DonutSample;

export const textCode = `
import React from 'react';
import { DonutDoubleEverywhere } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [{
    title: "Android",
    value: 40,
    color: "rgb(86,130,216)",
    subs: [{
        title: "Samsung",
        value: 20,
        color: "rgba(86,130,216,1)"
    }, {
        title: "HTC",
        value: 10,
        color: "rgba(86,130,216,0.75)"
    }, {
        title: "Samsung",
        value: 5,
        color: "rgba(86,130,216,0.5)"
    }, {
        title: "Other",
        value: 5,
        color: "rgba(86,130,216,0.25)"
    }]
}, {
    title: "Windows",
    value: 20,
    color: "rgb(188,98,218)"
}, {
    title: "Print",
    value: 20,
    color: "rgb(196,175,84)",
    subs: [{
        title: "Samsung",
        value: 10,
        color: "rgba(196,175,84,1)"
    }, {
        title: "HTC",
        value: 10,
        color: "rgba(196,175,84,0.75)"
    }]
}, {
    title: "Other",
    value: 20,
    color: "rgb(91,100,114)"
}];

class DonutSample extends React.Component {
    constructor() {
        super();
        this._onClickSlice = this._onClickSlice.bind(this);
    }
    _onClickSlice(event) {
        console.log(event);
    }
    render() {
        return (<DonutDoubleEverywhere data={data}
            maintitle='Pie Chart Title'
            internaltitle='Internal Title'
            internalvalue='12345'
            legendposition='bottom'
            labels={false}
            onClickSlice={this._onClickSlice}
            width='500px'
            height='400px'
        ></DonutDoubleEverywhere>);
    }
}

export default DonutSample;
`


export const src = `
const data = [{
    title: "Android",
    value: 40,
    subs: [{
        title: "Samsung",
        value: 20
    }, {
        title: "HTC",
        value: 10
    }, {
        title: "Samsung",
        value: 5
    }, {
        title: "Other",
        value: 5
    }]
}, {
    title: "Windows",
    value: 20
}, {
    title: "Print",
    value: 20,
    subs: [{
        title: "Samsung",
        value: 10
    }, {
        title: "HTC",
        value: 10
    }]
}, {
    title: "Other",
    value: 20
}];

const internaltext=[{
    position: "54%",
    size: 12,
    bold: true,
    text: 'Internal Title',
    color: '#58585b'
},{
    position: "42%",
    size: 32,
    bold: false,
    text: '1234',
    color: '#58585b'
}]

const template = "<donutdouble-everywhere ></donutdouble-everywhere>";

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template
        const element = document.querySelector("donutdouble-everywhere")
        element.data = data;
        element.internaltext = internaltext;
        element.labels = true;
        element.width = '550px';
        element.height = '400px';
        element.callouttext = '[[title]]: [[value]]%',
        element.tooltiptext = '[[title]]: [[value]]%'
    }
}
`



// WEBPACK FOOTER //
// ./src/samples/DoublePieChartHomeReact.js